import React from 'react';

interface LoadingOverlayProps {
  progress: { current: number; total: number } | null;
}

export function LoadingOverlay({ progress }: LoadingOverlayProps) {
  return (
    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="glass-panel p-6 text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[var(--accent-color)] mx-auto mb-4" />
        {progress && (
          <div className="text-[var(--primary-text)]">
            Loading squares: {progress.current} / {progress.total}
          </div>
        )}
      </div>
    </div>
  );
}